document.documentElement.classList.remove('no-js');
document.addEventListener('click', function(e){
  const open = document.querySelector('.nav details[open]');
  if(open && !open.contains(e.target)) open.removeAttribute('open');
});

function initMarineZoomGallery(root){
  const mainImage = root.querySelector('[data-main-image]');
  const openButton = root.querySelector('[data-gallery-open]');
  const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
  const lightbox = root.querySelector('[data-lightbox]');
  const lightboxImage = root.querySelector('[data-lightbox-image]');
  const counter = root.querySelector('[data-lightbox-count]');
  let currentIndex = 0;

  const images = thumbs.length ? thumbs.map(function(t){
    return { src: t.dataset.full, alt: t.dataset.alt || '' };
  }) : (mainImage ? [{ src: mainImage.src, alt: mainImage.alt || '' }] : []);

  function setCurrent(index){
    if(!images.length) return;
    currentIndex = (index + images.length) % images.length;
    const item = images[currentIndex];
    if(mainImage){ mainImage.src = item.src; mainImage.alt = item.alt; }
    if(lightboxImage){ lightboxImage.src = item.src; lightboxImage.alt = item.alt; }
    thumbs.forEach(function(t, i){ t.classList.toggle('is-active', i === currentIndex); });
    const galleryCounter = root.querySelector('[data-gallery-current]');
    if(galleryCounter) galleryCounter.textContent = currentIndex + 1;
    if(counter) counter.textContent = (currentIndex + 1) + ' / ' + images.length;
  }

  thumbs.forEach(function(thumb, index){
    thumb.addEventListener('click', function(){ setCurrent(index); });
  });

  function openLightbox(){
    if(!lightbox || !images.length) return;
    setCurrent(currentIndex);
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden','false');
    lightbox.classList.add('is-open');
    document.body.classList.add('mz-lightbox-open');
    const close = lightbox.querySelector('.mz-lightbox__close');
    if(close) close.focus();
  }

  function closeLightbox(){
    if(!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden','true');
    lightbox.classList.remove('is-open');
    document.body.classList.remove('mz-lightbox-open');
    if(openButton) openButton.focus();
  }

  if(openButton) openButton.addEventListener('click', openLightbox);
  if(lightbox){
    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function(btn){ btn.addEventListener('click', closeLightbox); });
    const prev = lightbox.querySelector('[data-lightbox-prev]');
    const next = lightbox.querySelector('[data-lightbox-next]');
    if(prev) prev.addEventListener('click', function(){ setCurrent(currentIndex - 1); });
    if(next) next.addEventListener('click', function(){ setCurrent(currentIndex + 1); });
  }

  document.addEventListener('keydown', function(e){
    if(!lightbox || lightbox.hidden) return;
    if(e.key === 'Escape') closeLightbox();
    if(e.key === 'ArrowLeft' && images.length > 1) setCurrent(currentIndex - 1);
    if(e.key === 'ArrowRight' && images.length > 1) setCurrent(currentIndex + 1);
  });

  setCurrent(0);
}

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-product-gallery]').forEach(initMarineZoomGallery);
});

document.addEventListener('click', function(e){
  const tab=e.target.closest('[data-tab-button]'); if(tab){const root=tab.closest('.product-tabs');root.querySelectorAll('[data-tab-button]').forEach(x=>x.classList.remove('is-active'));root.querySelectorAll('[data-tab-panel]').forEach(x=>x.classList.remove('is-active'));tab.classList.add('is-active');root.querySelector('[data-tab-panel="'+tab.dataset.tabButton+'"]').classList.add('is-active');}
  const gallery=e.target.closest('[data-product-gallery]'); if(!gallery)return;
  const thumbs=[...gallery.querySelectorAll('[data-thumb]')]; if(!thumbs.length)return;
  let active=thumbs.findIndex(x=>x.classList.contains('is-active')); if(active<0)active=0;
  if(e.target.closest('[data-gallery-prev]')) active=(active-1+thumbs.length)%thumbs.length;
  else if(e.target.closest('[data-gallery-next]')) active=(active+1)%thumbs.length; else return;
  const t=thumbs[active], img=gallery.querySelector('[data-main-image]'); img.src=t.dataset.full; img.alt=t.dataset.alt||''; thumbs.forEach(x=>x.classList.remove('is-active'));t.classList.add('is-active'); const c=gallery.querySelector('[data-gallery-current]');if(c)c.textContent=active+1;
});

// MarineZoom V23 — collection filters, brand search, and sorting.
document.addEventListener('DOMContentLoaded', function(){
  var sidebar=document.querySelector('[data-filter-sidebar]');
  var overlay=document.querySelector('.mz-filter-overlay');
  var toggle=document.querySelector('[data-filter-toggle]');
  var closers=document.querySelectorAll('[data-filter-close]');

  function setFilters(open){
    if(!sidebar)return;
    sidebar.classList.toggle('is-open',open);
    if(overlay)overlay.classList.toggle('is-open',open);
    document.body.classList.toggle('mz-filter-open',open);
  }

  if(toggle)toggle.addEventListener('click',function(){setFilters(true);});
  closers.forEach(function(el){el.addEventListener('click',function(){setFilters(false);});});

  document.querySelectorAll('[data-filter-search]').forEach(function(input){
    var group=input.closest('.mz-filter-group');
    if(!group)return;
    var options=Array.from(group.querySelectorAll('[data-filter-option]'));
    input.addEventListener('input',function(){
      var q=(input.value||'').trim().toLowerCase();
      options.forEach(function(option){
        var label=(option.getAttribute('data-filter-label')||'').toLowerCase();
        option.hidden=!!q && label.indexOf(q)===-1;
      });
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach(function(select){
    select.addEventListener('change',function(){
      if(select.form)select.form.submit();
    });
  });
});
